import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AUTHENTICATOR_ALGORITHM } from '../../../constants';
import { trans } from '../../../localization/language';
import * as authenticatorActions from '../../../actions/authenticator';
import cx from 'classnames';
import { QRCodeSVG } from 'qrcode.react';

class SaveAuthenticator extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			code: '',
			expandedCode: false
		}
	}
	
	handleSubmit(event) {
		event.preventDefault();
		this.props.saveAuthenticator(this.state.code);
	}
	
	handleChangeCode(event) {
		this.setState({code: event.target.value});
	}
	
	getQRCode() {
		var data = this.props.authenticator.seed + '|' + this.props.userInfo.username;
		if (this.props.userInfo.authenticator_algorithm === AUTHENTICATOR_ALGORITHM.GOOGLE) {
			var data = 'otpauth://totp/' + this.props.userInfo.username + '?secret=' + this.props.authenticator.seed + '&issuer=Garena';
		}
		return data;
	}
	handleExpand() {
		this.setState({
			expandedCode:!this.state.expandedCode
		});
	}

	renderGoogleAuthenticatorPCGuide() {
		return (
			<div className="setupauth-step-pc">
				<dl className="setupauth-step">
					<dt className="setupauth-step__title">{trans('setup_google_authenticator_step1_title')}</dt>
					<dd>
						<ul className="setupauth-step__list">
							<li className="setupauth-step__list-item">{trans('setup_google_authenticator_step1_item1')}</li>
							<li className="setupauth-step__list-item">{trans('setup_google_authenticator_step1_item2')}</li>
							<li className="setupauth-step__list-item">{trans('setup_google_authenticator_step1_item3')}</li>
						</ul>
					</dd>
				</dl>
				<dl className="setupauth-step">
					<dt className="setupauth-step__title">{trans('setup_google_authenticator_step2_title')}</dt>
					<dd>
						<ul className="setupauth-step__list">
							<li className="setupauth-step__list-item">{trans('setup_google_authenticator_step2_item1')}</li>
							<li className="setupauth-step__list-item">{trans('setup_google_authenticator_step2_item2')}</li>
							<li className="setupauth-step__list-item">{trans('setup_google_authenticator_step2_item3')}</li>
						</ul>
						<div className="setupauth-step__pcqr">
							<dl className={cx("setupauth-step__pcqr-dl","setupauth-step__pcqr-dl--visible")} onClick={()=>this.handleExpand()} style={{cursor: 'pointer'}}>
								<dd className="setupauth-step__pcqr-dd">
									{this.state.expandedCode
										? this.props.authenticator.seed
										: '********************************'}
								</dd>
							</dl>
							<div className="setupauth-step__pcqr-top">
								<QRCodeSVG
									alt="QR Code"
									className="setupauth-step__pcqr-img"
									value={this.getQRCode()}
									size={150}
									marginSize={0}
									level="H"
								/>
							</div>
						</div>
					</dd>
				</dl>
				<dl className="setupauth-step">
					<dt className="setupauth-step__title">{trans('setup_google_authenticator_step3_title')}</dt>
					<dd>
						<ul className="setupauth-step__list">
							<li className="setupauth-step__list-item">{trans('setup_google_authenticator_step3_item1')}</li>
						</ul>
					</dd>
				</dl>
			</div>
		);
	}
	
	renderPCGuide() {
		if (this.props.userInfo.authenticator_algorithm === AUTHENTICATOR_ALGORITHM.GOOGLE) {
			return this.renderGoogleAuthenticatorPCGuide();
		}
		return (
			<div className="setupauth-step-pc">
				<dl className="setupauth-step">
					<dt className="setupauth-step__title">{trans('setup_authenticator_step1_title')}</dt>
					<dd>
						<ul className="setupauth-step__list">
							<li className="setupauth-step__list-item">{trans('setup_authenticator_step1_item1')}</li>
							<li className="setupauth-step__list-item">{trans('setup_authenticator_step1_item2')}</li>
							<li className="setupauth-step__list-item">{trans('setup_authenticator_step1_item3')}</li>
						</ul>
					</dd>
				</dl>
				<dl className="setupauth-step">
					<dt className="setupauth-step__title">{trans('setup_authenticator_step2_title')}</dt>
					<dd>
						<ul className="setupauth-step__list">
							<li className="setupauth-step__list-item">{trans('setup_authenticator_step2_item1')}</li>
							<li className="setupauth-step__list-item">{trans('setup_authenticator_step2_item2')}</li>
						</ul>
						<div className="setupauth-step__pcqr">
							<div className="setupauth-step__pcqr-top">
								<QRCodeSVG
									alt="QR Code"
									className="setupauth-step__pcqr-img"
									value={this.getQRCode()}
									size={150}
									marginSize={0}
									level="H"
								/>
								<a className={cx("setupauth-step__pcqr-info",{"setupauth-step__pcqr-info--expanded":this.state.expandedCode})} onClick = {()=>this.handleExpand()}>
													<span className="setupauth-step__pcqr-info-before">
														{trans('setup_authenticator_tip_info')}
													</span>
													<span className="setupauth-step__pcqr-info-after">
														{trans('setup_authenticator_tip_collapse')}
													</span>
								</a>
							</div>
							<dl className={cx("setupauth-step__pcqr-dl",{"setupauth-step__pcqr-dl--visible":this.state.expandedCode})}>
								<dt className="setupauth-step__pcqr-dt">{trans('tips')}:</dt>
								<dd className="setupauth-step__pcqr-dd">
									<ul className="setupauth-step__pcqr-tips">
										<li className="setupauth-step__pcqr-tips-item">{trans('setup_authenticator_tip1')}</li>
										<li className="setupauth-step__pcqr-tips-item">{trans('setup_authenticator_tip2')}</li>
										<li className="setupauth-step__pcqr-tips-item">{trans('setup_authenticator_tip3')}</li>
										<li className="setupauth-step__pcqr-tips-item">{trans('setup_authenticator_tip4')}:
											<div className="setupauth-step__pcqr-tips-code">{this.props.authenticator.seed}</div></li>
										<li className="setupauth-step__pcqr-tips-item">{trans('setup_authenticator_tip5')}</li>
									</ul>
								</dd>
							</dl>
						</div>
						<ul className="setupauth-step__list">
							<li className="setupauth-step__list-item">{trans('setup_authenticator_step2_item3')}</li>
						</ul>
					</dd>
				</dl>
			</div>
		);
	}

	renderGoogleAuthenticatorMobileGuide() {
		return (
			<div className="setupauth-step-mobile">
				<dl className="setupauth-step">
					<dt className="setupauth-step__title">{trans('setup_google_authenticator_step1_title')}</dt>
					<dd>
						<div className="setupauth-step__appdl">
							<a href="#" className="setupauth-step__appdl-appstore"></a>
							<a href="#" className="setupauth-step__appdl-googleplay"></a>
						</div>
					</dd>
				</dl>
				<dl className="setupauth-step">
					<dt className="setupauth-step__title">{trans('setup_google_authenticator_step2_title')}</dt>
					<dd>
						<div className="setupauth-step__mqr">
							<QRCodeSVG
								id="J-sauth-qrpop-trigger"
								alt="QR Code"
								className="setupauth-step__mqr-img"
								value={this.getQRCode()}
								size={150}
								marginSize={0}
								level="H"
							/>
						</div>
						<ul className="setupauth-step__list">
							<li className="setupauth-step__list-item">{trans('setup_google_authenticator_step2_item1')}</li>
							<li className="setupauth-step__list-item">{trans('setup_google_authenticator_step2_item2')}</li>
							<li className="setupauth-step__list-item">{trans('setup_google_authenticator_step2_item3')}</li>
							<div className="setupauth-step__mqr-code">
								{this.props.authenticator.seed}
							</div>
							<li className="setupauth-step__list-item">{trans('setup_google_authenticator_step3_item1')}</li>
						</ul>
					</dd>
				</dl>
			</div>
		);
	}

	renderMobileGuide() {
		if (this.props.userInfo.authenticator_algorithm === AUTHENTICATOR_ALGORITHM.GOOGLE) {
			return this.renderGoogleAuthenticatorMobileGuide();
		}
		return (
			<div className="setupauth-step-mobile">
				<dl className="setupauth-step">
					<dt className="setupauth-step__title">{trans('setup_authenticator_step1_title')}</dt>
					<dd>
						<div className="setupauth-step__appdl">
							<a href="#" className="setupauth-step__appdl-appstore"></a>
							<a href="#" className="setupauth-step__appdl-googleplay"></a>
						</div>
					</dd>
				</dl>
				<dl className="setupauth-step">
					<dt className="setupauth-step__title">{trans('setup_authenticator_step2_title')}</dt>
					<dd>
						<ul className="setupauth-step__list">
							<li className="setupauth-step__list-item">{trans('security_key_message')}</li>
						</ul>
						<div className="setupauth-step__mqr">
							<QRCodeSVG
								id="J-sauth-qrpop-trigger"
								alt="QR Code"
								className="setupauth-step__mqr-img"
								value={this.getQRCode()}
								size={150}
								marginSize={0}
								level="H"
							/>
							<div className="setupauth-step__mqr-code">
								{this.props.authenticator.seed}
							</div>
						</div>
						<ul className="setupauth-step__list">
							<li className="setupauth-step__list-item">{trans('setup_authenticator_mobile_step1')}</li>
							<li className="setupauth-step__list-item">{trans('setup_authenticator_mobile_step2')}</li>
							<li className="setupauth-step__list-item">{trans('setup_authenticator_mobile_step3')}</li>
							<li className="setupauth-step__list-item">{trans('setup_authenticator_mobile_step4')}</li>
							<li className="setupauth-step__list-item">{trans('setup_authenticator_mobile_step5')}</li>
							<li className="setupauth-step__list-item">{trans('setup_authenticator_mobile_step6')}</li>
						</ul>
					</dd>
				</dl>
			</div>
		);
	}
	
	getErrorDiv() {
		var errMsg = null;
		if (this.props.authenticator.status) {
			errMsg = trans('error_code');
		}
		if (errMsg) {
			return (
				<div className="content__form-errmsg-item content__form-errmsg-item--visible">
					{errMsg}
				</div>
			);
		}
		return null;
	}

	render() {
		return (
			<div className="content">
				<div className="content-item content-item--ipage">
					<div className="content-item__title">
						{ this.props.userInfo.authenticator_algorithm === AUTHENTICATOR_ALGORITHM.GOOGLE
							? trans('setup_google_authenticator_title')
							: trans('setup_authenticator_title')
						}
					</div>
					<div className="content-item__main">
						<div className="content-item--ipage__main">
							{this.renderPCGuide()}
							{this.renderMobileGuide()}
							<div className="content__form setupauth-step__form">
								<form method="post" action="" id="J-validated-form" onSubmit={this.handleSubmit.bind(this)}>
									<div className="content__form-input">
										<input type="tel" maxLength="6" 
											className="content__form-input-widget J-validated-field" 
											placeholder={trans('verify_code_placeholder')}
											onChange={this.handleChangeCode.bind(this)}>
										</input>
									</div>
									<div className="content__form-errmsg" id="J-errdisplay-otp">
										{this.getErrorDiv()}
									</div>
									<div className="content__submit-wrap">
										<input type="submit" className="content__submit" value={trans('verify_and_setup_btn')}></input>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
		authenticator: state.authenticator
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, authenticatorActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SaveAuthenticator);



// WEBPACK FOOTER //
// ./app/components/security/authenticator/SaveAuthenticator.js